export const payoutRoutes = {
	payouts: (query: string) => `/payouts/${query ? `?${query}` : ''}`,
	payout: (id: string) => `/payouts/${id}/`,
	payoutHistory: (id: string) => `/payouts/${id}/history/`,
	payoutsExport: '/payouts/export/',
	payoutsBulkStatus: '/payouts/bulk_status/',
	payoutPrint: (id: number) => `/payouts/${id}/html/`
}
